import { setContactSalesModal, setPlansModalShow, setPricingPlan, setPurchasePlanModal } from '../../../../../store/workspace/slice';
import { LayerIcon, FlagSquareIcon, TargetSquareIcon, GemSquareIcon, ArrowRightIcon } from '../../../../../assets/icons';
import { selectProfile, selectSelectedPricingPlan } from '../../../../../store/workspace/selectors';
import { useDispatch, useSelector } from '../../../../../store/store';
import { PricingPlan } from '../../../../../store/workspace/types';
import CheckBox from '../../../../../components/CheckBox';
import Button from '../../../../../components/Button';
import { accountPlans } from '../../../../../configs';
import Modal from '../../../../../components/Modal';
import styles from './style.module.scss';
import { useState } from 'react';

type Tab = 'monthly' | 'yearly';
const landingUrl = process.env.REACT_APP_LANDING_URL;
const modalDescription = 'Please choose a plan or contact sales to continue.';

export default function PlansModal() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const [tab, setTab] = useState<Tab>('yearly');
    const selectedPlan = useSelector(selectSelectedPricingPlan);

    const confirmFunc = () => {
        dispatch(setPlansModalShow(false));
        dispatch(setPurchasePlanModal(true));
    };

    const setPlan = (plan: PricingPlan) => {
        if (!plan.active) return;
        if (profile?.planType === plan.id) return;
        if (profile?.planType?.includes('professional') && plan.name === 'Standard') return;
        if (profile?.planType === 'standard_annual' && plan.id === 'standard_monthly') return;
        dispatch(setPricingPlan(plan));
    };

    const openContactSales = () => {
        window.open(`${landingUrl}/book-demo`, '_blank');
    };

    const changeTab = (newTab: Tab) => {
        if (newTab === tab) return;
        setTab(newTab);
        dispatch(setPricingPlan(null));
    };

    return (
        <Modal
            size='xxl'
            title='Select plan'
            icon={<LayerIcon />}
            description={modalDescription}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setPlansModalShow(false))}
        >
            <div className={styles.banner}>
                <span className={styles.banner_text}>
                    Upgrade to enterprise for more features by contacting sales.
                </span>
                <div
                    className={styles.banner_btn}
                    onClick={openContactSales}
                >
                    <span>Contact sales</span>
                    <ArrowRightIcon />
                </div>
            </div>
            <div className={styles.tabs}>
                <div
                    className={styles.tab}
                    data-is-active={tab === 'yearly'}
                    onClick={() => changeTab('yearly')}
                >
                    Yearly -20% off
                </div>
                <div
                    className={styles.tab}
                    data-is-active={tab === 'monthly'}
                    onClick={() => changeTab('monthly')}
                >
                    Monthly
                </div>
            </div>
            <div className={styles.plan_list}>
                {accountPlans[tab].map(plan => {
                    const coverText =
                        profile?.planType === plan.id ? 'Current plan' :
                            plan.name === 'Basic' ? 'You have already used this plan' : null;

                    return (
                        <div
                            key={plan.id}
                            className={styles.plan}
                            onClick={() => setPlan(plan)}
                            data-is-selected={selectedPlan?.id === plan.id}
                        >
                            {(profile?.planType !== plan.id) && plan.name !== 'Basic' &&
                                <CheckBox
                                    checked={selectedPlan?.id === plan.id}
                                    className={styles.plan_checkBox}
                                    onClick={() => setPlan(plan)}
                                />}
                            {plan.icon === 'gem' && <GemSquareIcon />}
                            {plan.icon === 'flag' && <FlagSquareIcon />}
                            {plan.icon === 'target' && <TargetSquareIcon />}
                            <div className={styles.plan_name}>
                                {plan.name}
                                {plan.name === 'Standard' &&
                                    <span className={styles.plan_name_badge}>
                                        Popular
                                    </span>}
                            </div>
                            <span className={styles.plan_slogan}>{plan.slogan}</span>
                            <span className={styles.plan_price}>{plan.price} <b>{plan.per}</b> </span>
                            <div className={styles.plan_check_list}>
                                {plan.checkList.map((item, indx) =>
                                    <div
                                        key={indx}
                                        className={styles.plan_check_list_item}
                                    >
                                        <span className={styles.text}>{item}</span>
                                    </div>)}
                            </div>
                            {coverText &&
                                <div className={styles.plan_cover}>
                                    <span>{coverText}</span>
                                </div>}
                        </div>
                    );
                })}
            </div>
            <div className={styles.actions}>
                <Button
                    type='Outline-Primary'
                    text='Cancel'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setPlansModalShow(false))}
                />
                <Button
                    type='Primary'
                    text='Confirm'
                    disabled={!selectedPlan}
                    onClick={confirmFunc}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    );
};
